import React from 'react'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
import DetailDoctorService from '../Service/DetailDoctorService'
import './doctortreatment.css'

export default class formInput extends React.Component {

    render() {
        const { changeHandler, saveHandler, Model, ShowModal, cancelHandler, errors, Mode } = this.props

        return (
            <div class="mb-10">

                <Modal show={ShowModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-3 ">
                            <label for="name" class="form-label tindakan">Tindakan *</label>
                            {/* <input type="text" class="form-control" id="name" placeholder="Masukkan Tindakan" onChange={changeHandler("name")}></input> */}
                            <input type="text" class="form-control font1" id="name" placeholder="Masukkan Tindakan" value={Model.name} onChange={changeHandler("name")}></input>

                            <span className="error" class="error">{errors["name"]}</span>
                            <span className="error" class="error">{errors["nameEmpty"]}</span>
                            <span className="error">{errors["name_existed"]}</span>

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button type="button" class="btn btn-success" onClick={saveHandler} >Simpan</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
